export default {
    configuration: "Paramètres",
    boiteskformulaire: "Boîte",
    boitesk: "Boîte",
    boites: {
        archive_records_count: "Nb de dossiers",
        archive_record_ids: {
            length: "Nb de dossiers associés",
        },
        index: "Liste des boîtes",
        add: "Créer boîte",
        archive_room: {
            index: "Salle d'archive",
            name: "Salle d'archive",
            v: "Salle d'archive",
        },
        box_width: {
            index: "Largeur (m)",
            v: "Largeur (m)",
        },
        box_width_value: "Largeur (m)",
        cabinet: {
            index: "Travée",
            v: "Travée",
        },
        cabinet_from_cluster: "Travée d'épi",
        cabinet_number: "Travée",
        cabinet_cluster: {
            index: "Épi",
            v: "Épi",
        },
        cabinet_cluster_number: "Épi",
        cote_extreme: "Cote Extrême",
        delete: {
            index: "Supprimer boîte",
            text: "Confirmez-vous la suppression ?",
            title: "Confirmer suppression",
        },
        dossiers: "Liste des dossiers d'une boite",
        id: "Boîte",
        epci_commune_id: "EPCI ou Commune",
        epci_commune: {
            index: "EPCI ou Commune",
            v: "EPCI ou Commune",
        },
        hamlet: {
            index: "Hameau",
            name: "Hameau",
            v: "Hameau",
        },
        hamlet_archive_room: "Salle d'archive d'un hameau",
        hamlet_name: "Hameau",
        has_cabinet_cluster: "Épi ?",
        has_hamlet: "Hameau ?",
        name: "Boîte",
        number: "Numéro",
        rack: {
            index: "Tablette",
            v: "Tablette",
        },
        rack_letter: "Tablette",
        toaster: {
            POST: {
                success: {
                    title: "Boîte",
                    text: "La boite : {name} a été enregistré",
                },
                error: {
                    title: "Boîte",
                    text: "La boite : {name} n'a pas été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Boîte",
                    text: "La boite : {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Boîte",
                    text: "La boite a été supprimé",
                },
            },
        },
    },
    epcicommuneskformulaire: "Communes et EPCI",
    epcicommunesk: "Communes et EPCI",
    parametres: {
        index: "Paramètre",
        epcicommunes: "Paramètres - Communes et EPCI",
        dureeutiliteadministrative: "Paramètres - Durée d'utilité administrative",
        delaiscommunicabilite: "Paramètres - Délais de communicabilité",
        listeindex: "Paramètres - Index",
        series: "Paramètres - Séries",
        sousseries: "Paramètres - Sous-séries",
        procedure: "Paramètres - Procédure",
        documentsprocedure: "Paramètres - Documents vierge pour les procédures",
    },
    epcicommunes: {
        index: "Liste des Communes et EPCI",
        add: "Ajouter commune ou EPCI",
        delete: {
            index: "Supprimer commune ou EPCI",
            text: "Confirmez-vous la suppression ?",
            title: "Confirmer suppression",
        },
        id: "Commune ou EPCI",
        name: "Commune ou EPCI",
        classification_type: {
            index: "Type de classification",
            W: "W",
            S: "S",
        },
        archive_rooms: {
            index: "Salle d'archive",
            cabinets_count: "Nombre de travées",
            cabinet_clusters_count: "Nombre d'épis",
            has_clusters: "Épi",
            name: "Salle d'archive",
            v: "Salle d'archive",
        },
        cabinet_clusters: {
            index: "Épi",
            cabinets_count: "Nombre de travées dans l'épi",
            number: "Numéro d'épi",
        },
        logo: "Logo",
        image1: "Image 1",
        image2: "Image 2",
        custom_column: "Inventaire",
        hamlets: {
            index: "Hameau",
            name: "Hameau",
            archive_rooms: {
                index: "Salle d'archive Hameau",
                name: "Salle d'archive Hameau",
                cabinets_count: "Nombre de travées",
                cabinet_clusters_count: "Nombre d'épis",
                has_clusters: "Épi",
            },
        },
        has_hamlets: {
            index: "Hameau",
            true: "Oui",
            false: "Non",
        },
        status_mission: {
            index: "Statut mission",
            quotation: "Devis",
            pending: "En attente",
            in_progress: "En cours",
            completed: "Réalisé",
            terminated: "Résilié",
        },
        versement_number: "n° de versement en cours",
        introduction: "Introduction (inventaire)",
        archive_record_count: "Nombre de dossiers",
        accessible_communes: "Commune(s) ou EPCI associée(s)",
        toaster: {
            POST: {
                success: {
                    title: "Commune ou EPCI",
                    text: "La Commune ou EPCI : {name} a été enregistré",
                },
                error: {
                    title: "Commune ou EPCI",
                    text: "La Commune ou EPCI : {name} n'a pas été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Commune ou EPCI",
                    text: "La Commune ou EPCI : {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Commune ou EPCI",
                    text: "La Commune ou EPCI a été supprimé",
                },
            },
        },
        v: "Commune ou EPCI",
    },
    dureeutiliteadministrativekformulaire: "Durée d'utilité administrative",
    dureeutiliteadministrativek: "Durée d'utilité administrative",
    dureeutiliteadministrative: {
        index: "Durée d'utilité administrative",
        add: "Ajouter durée d'utilité administrative",
        comment: "Commentaire",
        delete: {
            index: "Supprimer",
            text: "Confirmez-vous la suppression ?",
            title: "Confirmer suppression de la durée d'utilité administrative",
        },
        duration: "Durée",
        id: "Durée d'utilité administrative",
        name: "Durée d'utilité administrative",
        toaster: {
            POST: {
                success: {
                    title: "Durée d'utilité administrative",
                    text: "La durée d'utilité administrative : {name} a été enregistré",
                },
                error: {
                    title: "Durée d'utilité administrative",
                    text: "La durée d'utilité administrative : {name} n'a pas été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Durée d'utilité administrative",
                    text: "La durée d'utilité administrative : {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Durée d'utilité administrative",
                    text: "La durée d'utilité administrative a été supprimé",
                },
            },
        },
        unit: {
            index: "Unité",
            day: "jour(s)",
            month: "mois",
            year: "année(s)",
        },
    },
    delaiscommunicabilitekformulaire: "Délais de communicabilité",
    delaiscommunicabilitek: "Délais de communicabilité",
    delaiscommunicabilite: {
        index: "Délais de communicabilité",
        add: "Ajouter délais de communicabilité",
        comment: "Commentaire",
        delete: {
            index: "Supprimer",
            text: "Confirmez-vous la suppression ?",
            title: "Confirmer suppression du délais de communicabilité",
        },
        duration: "Durée",
        id: "Délais de communicabilité",
        name: "Délais de communicabilité",
        toaster: {
            POST: {
                success: {
                    title: "Délais de communicabilité",
                    text: "Le délais de communicabilité : {name} a été enregistré",
                },
                error: {
                    title: "Délais de communicabilité",
                    text: "Le délais de communicabilité : {name} n'a pas été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Délais de communicabilité",
                    text: "Le délais de communicabilité : {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Délais de communicabilité",
                    text: "Le délais de communicabilité a été supprimé",
                },
            },
        },
        unit: {
            index: "Unité",
            day: "jour(s)",
            month: "mois",
            year: "année(s)",
        },
    },
    listeindexkformulaire: "Index",
    listeindexk: "Index",
    listeindex: {
        index: "Index",
        add: "Ajouter index",
        delete: {
            index: "Supprimer index",
            text: "Confirmez-vous la suppression ?",
            title: "Confirmer suppression",
        },
        id: "Index",
        name: "Index",
        toaster: {
            POST: {
                success: {
                    title: "Index",
                    text: "L'intitulé de l'index : {name} a été enregistré",
                },
                error: {
                    title: "Index",
                    text: "L'intitulé de l'index : {name} n'a pas été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Index",
                    text: "L'intitulé de l'index : {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Index",
                    text: "L'intitulé de l'index a été supprimé",
                },
            },
        },
    },
    missionskformulaire: "Missions",
    missionsk: "Missions",
    missions: {
        index: "Liste des missions",
        add: "Ajouter missions",
        affiliated: {
            index: "Affiliation",
            true: "Affilié",
            false: "Non affilié",
        },
        classification_type: {
            index: "Type de classification",
            W: "W",
            S: "S",
        },
        archive_rooms: {
            index: "Salle d'archive",
            cabinets_count: "Nombre de travées",
            cabinet_clusters_count: "Nombre d'épis",
            has_clusters: "Épi",
            name: "Salle d'archive",
            v: "Salle d'archive",
        },
        cabinet_clusters: {
            index: "Épi",
            cabinets_count: "Nombre de travées dans l'épi",
            number: "Numéro d'épi",
        },
        logo: "Logo",
        image1: "Image 1",
        image2: "Image 2",
        custom_column: "Inventaire",
        delete: {
            index: "Supprimer missions",
            text: "Attention ! La suppression de cette misssion entraînera la perte de tous les dossiers de cette mission. Confirmez-vous la suppression ?",
            title: "Confirmer suppression de cette mission",
        },
        epci_commune_id: "EPCI ou Commune",
        epci_commune: {
            index: "EPCI ou Commune",
            v: "EPCI ou Commune",
        },
        hamlets: {
            index: "Hameau",
            name: "Hameau",
            archive_rooms: {
                index: "Salle d'archive Hameau",
                name: "Salle d'archive Hameau",
                cabinets_count: "Nombre de travées",
                cabinet_clusters_count: "Nombre d'épis",
                has_clusters: "Épi",
            },
        },
        has_hamlets: "Hameau",
        measurement_done: "Métrage effectué",
        measurement_estimate: "Métrage devis",
        status_mission: {
            index: "Statut mission",
            quotation: "Devis",
            pending: "En attente",
            in_progress: "En cours",
            completed: "Réalisé",
            terminated: "Résilié",
        },
        start: "Début de mission",
        end: "Fin de mission",
        toaster: {
            POST: {
                success: {
                    title: "Espace mission",
                    text: "Les informations {name} ont été enregistrées",
                },
                error: {
                    title: "Espace mission",
                    text: "Les informations {name} n'ont pas été enregistrées",
                },
            },
            PUT: {
                success: {
                    title: "Espace mission",
                    text: "Les informations {name} ont été enregistrées",
                },
            },
            DELETE: {
                success: {
                    title: "Mission",
                    text: "La mission a été supprimée",
                },
            },
        },
        total_capacity: "Métrage total (capacité)",
        workload_done: "Temps passé pour la mission (en jours)",
        workload_estimate: "Temps estimée (en jours)",
    },
    serieskformulaire: "Série",
    seriesk: "Série",
    series: {
        index: "Séries",
        add: "Ajouter série",
        code: "Code",
        delete: {
            index: "Supprimer série",
            text: "Confirmez-vous la suppression ?",
            title: "Confirmer suppression",
        },
        id: "Série",
        name: "Série",
        is_seriel: {
            index: "Classement Seriel",
            true: "Oui",
            false: "Non",
        },
        toaster: {
            POST: {
                success: {
                    title: "Série",
                    text: "L'intitulé de série : {name} a été enregistré",
                },
                error: {
                    title: "Série",
                    text: "L'intitulé de série : {name} n'a pas été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Série",
                    text: "L'intitulé de série : {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Série",
                    text: "L'intitulé de série a été supprimé",
                },
            },
        },
        v: "Séries",
    },
    sousserieskformulaire: "Sous-série",
    sousseriesk: "Sous-série",
    sousseries: {
        index: "Sous-séries",
        add: "Ajouter sous-série",
        code: "Code sous-série",
        delete: {
            index: "Supprimer sous-série",
            text: "Confirmez-vous la suppression ?",
            title: "Confirmer suppression",
        },
        id: "Sous-série",
        is_seriel: {
            index: "Classement Seriel",
            true: "Oui",
            false: "Non",
        },
        name: "Sous-série",
        series_id: "Séries",
        series: {
            index: "Séries",
            code: "Code série",
            v: "Séries",
        },
        toaster: {
            POST: {
                success: {
                    title: "Série",
                    text: "L'intitulé de sous-série : {name} a été enregistré",
                },
                error: {
                    title: "Série",
                    text: "L'intitulé de sous-série : {name} n'a pas été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Série",
                    text: "L'intitulé de sous-série : {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Série",
                    text: "L'intitulé de série a été supprimé",
                },
            },
        },
    },
    utilisateurskformulaire: "Utilisateurs",
    utilisateursk: "Utilisateurs",
    utilisateurs: {
        add: "Ajouter utilisateur",
        delete: {
            index: "Désactiver l'utilisateur",
            text: "Confirmez-vous la désactivation ?",
            title: "Confirmer désactivation",
        },
        restore: "Réactiver l'utilisateur",
        index: "Liste des utilisateurs",
        first_name: "Prénom",
        last_name: "Nom",
        deleted: "Désactivé",
        email: "Email",
        function: "Fonction",
        epci_commune_id: "EPCI ou Commune",
        epci_commune: {
            index: "EPCI ou Commune",
            v: "EPCI ou Commune",
        },
        role: {
            index: "Rôle",
            admin: "Administrateur",
            superuser: "Super Utilisateur",
            user: "Utilisateur",
        },
        toaster: {
            POST: {
                success: {
                    title: "Compte utilisateur",
                    text: "Les informations {name} ont été enregistrées",
                },
            },
            PUT: {
                success: {
                    title: "Compte utilisateur",
                    text: "Les informations {name} ont été enregistrées",
                },
            },
            DELETE: {
                success: {
                    title: "Compte utilisateur",
                    text: "Le compte utilisateur a été supprimé",
                },
            },
        },
    },
    profil: "Profile",
    profile: {
        add: "Ajouter profile",
        index: "Profiles",
        first_name: "Prénom",
        last_name: "Nom",
        email: "Email",
        function: "Fonction",
        epci_commune_id: "EPCI ou Commune",
        epci_commune: "EPCI ou Commune",
        role: "Rôle",
        password: "Nouveau mot de passe",
        passwordConfirm: "Confirmation mot de passe",
        toaster: {
            POST: {
                success: {
                    title: "Compte profile",
                    text: "Les informations {name} ont été enregistrées",
                },
            },
            PUT: {
                success: {
                    title: "Compte profile",
                    text: "Les informations {name} ont été enregistrées",
                },
            },
            DELETE: {
                success: {
                    title: "Compte profile",
                    text: "Le compte profile a été supprimé",
                },
            },
        },
    },
    dossierskformulaire: "Modification du dossier",
    dossiersk: "Visualiser un dossier",
    dossiers: {
        measurement: "Métrage",
        add: "Ajouter un dossier",
        index: "Dossiers",
        list: "Liste des dossiers",
        index_1: {
            v: "Index 1",
        },
        index_2: {
            v: "Index 2",
        },
        cote: "Cote",
        v: "Cote",
        box_id: "Boîte",
        box: {
            index: "Boîte",
            v: "Boîte",
            number: "Boîte",
        },
        where_in_hamlet: "Hameaux",
        k: {
            formulaire: "Modification dossier",
        },
        classification_type: {
            index: "Type de classification",
            W: "W",
            S: "S",
        },
        delete: {
            index: "Supprimer",
            title: "Supprimer le dossier {v}",
            text: "Cette opération est irréversible, veuillez confirmer.",
        },
        cabinet: {
            index: "Travée",
            v: "Travée",
        },
        cabinet_cluster: {
            index: "Épi",
            v: "Épi",
        },
        rack: {
            index: "Tablette",
            v: "Tablette",
        },
        archive_room: {
            index: "Salle d'archive",
            v: "Salle d'archive",
        },
        // final_state: "Sort final",
        regulatory_elimination_year: "Année d'élimination réglementaire",
        sub_series_archive_number: "Num archive sous-série",
        continuous_archive_number: "Num archive continue",
        min_year: "Année minimum",
        max_year: "Année maximum",
        typology: "Typologie des documents",
        thematic: "Description et précision du dossier",
        observation: "Observation",
        register: "Registre",
        document_producer: "Producteur du document",
        series: {
            index: "Série",
            name: "Série",
            v: "Série",
        },
        created_at: "Création",
        updated_at: "Modification",
        sub_series: {
            index: "Sous-série",
            name: "Sous-série",
            v: "Sous-série",
        },
        status: {
            index: "Statut",
            ToBeSorted: "A trier",
            Canceled: "Annulé",
            ToBeDestroyed: "À détruire",
            ToBeTransferred: "À verser",
            Archived: "Archivé",
            Transferred: "Versé",
            Destroyed: "Détruit",
            Released: "Sorti",
        },
        communication_delay: {
            index: "Délais de communicabilité",
            unit: {
                year: "an(s)",
                month: "mois",
                day: "jour(s)",
            },
        },
        administrative_retention_period: {
            index: "Durée d'utilité administrative",
            unit: {
                year: "an(s)",
                month: "mois",
                day: "jour(s)",
            },
        },
        series_id: {
            index: "Série",
        },
        sub_series_id: {
            index: "Sous-série",
        },
        mission: {
            index: "Mission",
            v: "Mission",
            epci_commune: {
                v: "Mission",
            },
        },
        mission_id: "Mission",
        epci_commune: {
            index: "Commune ou EPCI",
            v: "Commune ou EPCI",
        },
        epci_commune_id: "Commune ou EPCI",
        toaster: {
            POST: {
                success: {
                    title: "Dossier",
                    text: "Le dossier {name} a été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Dossier",
                    text: "Le dossier {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Dossier",
                    text: "Le dossier {name} a été enregistré",
                },
            },
        },
    },
    procedure: {
        index: "Procédure",
        add_archive_records: "Voulez-vous ajouter des dossiers ?",
        d: {
            index: "Destruction",
            add: "Nouveau suivi d'élimination",
            title: "Liste des suivi d'élimination",
            editTitle: "Suivi d'une procédure d'élimination",
            displayTitle: "Suivi d'une procédure d'élimination",
            measurement: "Métrage des dossiers à détruire / détruits",
        },
        v: {
            index: "Versement",
            add: "Nouveau suivi de versement",
            title: "Liste des suivi de versements",
            editTitle: "Suivi de versement",
            displayTitle: "Suivi de versement",
            measurement: "Métrage des dossiers à verser / versé",
        },
        dossiers: "Liste des dossiers d'un suivi",
        documents: {
            index: "Documents vierge pour les procédures",
            versement: "Modèle de Bordereau de dépôt",
            destruction: "Modèle de Bordereau d'élimination",
            attestation: "Modèle d'attestation sur l'honneur",
        },
        initial_demand: "Bordereau non-signé",
        approval_answer: "Réponse de la demande",
        proof_of_execution: "Justificatif",
        delete: "Supprimer",
        created_at: "Création",
        updated_at: "Modification",
        mission: {
            index: "Mission",
            v: "Mission",
            epci_commune: {
                v: "Mission",
            },
        },
        mission_id: "Mission",
        name: "Nom du suivi",
        procedure_type: {
            index: "Type de procédure",
            d: "élimination",
            v: "versement",
        },
        procedure_status: {
            index: "Statut du suivi",
            in_progress: "En cours",
            accepted: "Acceptée",
            denied: "Refusée",
            completed: "Réalisée",
            aborted: "Abandon",
        },
        toaster: {
            POST: {
                success: {
                    title: "Procédure",
                    text: "La procédure {name} a été enregistré",
                },
            },
            PUT: {
                success: {
                    title: "Procédure",
                    text: "La procédure {name} a été enregistré",
                },
            },
            DELETE: {
                success: {
                    title: "Procédure",
                    text: "La procédure {name} a été enregistré",
                },
            },
        },
    },
    fichedesuivik: "Consultation fiche de suivi",
    fichedesuivikformulaire: "Modification d'une fiche de suivi",
    fichedesuivi: {
        index: "Liste des fiches de suivi",
        add: "Nouvelle fiche de suivi",
        archive_records_count: "Nombre de dossiers",
        borrower_lastname: "Nom de l'emprunteur",
        borrower_firstname: "Prénom de l'emprunteur",
        custodian_lastname: "Nom du responsable",
        custodian_firstname: "Prénom du responsable",
        custodian_function: "Fonction du responsable",
        custom_column: "Fiche de suivi Pdf",
        delete: {
            index: "Supprimer fiche de suivi",
            text: "Confirmez-vous la suppression ?",
            title: "Confirmer suppression",
        },
        dossiers: "Dossiers associés à la fiche",
        start_date: "Date de début",
        end_date: "Date de fin",
        name: "Nom de la fiche",
        status: {
            index: "Status du suivi",
            active: "En cours",
            completed: "Terminé",
        },
        toaster: {
            POST: {
                success: {
                    title: "Fiche de suivi",
                    text: "Les informations {name} ont été enregistrées",
                },
            },
            PUT: {
                success: {
                    title: "Fiche de suivi",
                    text: "Les informations {name} ont été enregistrées",
                },
            },
            DELETE: {
                success: {
                    title: "Fiche de suivi",
                    text: "Le compte utilisateur a été supprimé",
                },
            },
        },
    },
    statistiques: {
        index: "Statistiques",
    },
    inventaire: {
        index: "Inventaire",
    },
}
